var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortIcon02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86603 6C4.48113 6.66667 3.51887 6.66667 3.13397 6L0.535898 1.5C0.150998 0.833335 0.632122 7.31543e-07 1.40192 6.64245e-07L6.59807 2.09983e-07C7.36788 1.42685e-07 7.849 0.833334 7.4641 1.5L4.86603 6Z",
    fill: "#FF3667",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon02);
export default __webpack_public_path__ + "static/media/sort-icon-02.0b9e29f81ff9080f14eebdb1e8c627ec.svg";
export { ForwardRef as ReactComponent };